


































































































































































import { changeLoading } from '@/util/plugins';
import { Component, Vue } from 'vue-property-decorator';
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  add: `${FCAPI}/shang/ruan/realcase`,
  get_detail: `${FCAPI}/shang/ruan/cases/`,
  get_list: `${FCAPI}/shang/ruan/style`,
  get_cummunity_list: `${FCAPI}/shang/ruan/community/name`,
};
const UPLOAD_DIR = {
  list_image: 'list_image', // 列表图
  house_image: 'house_image', // 户型图
  detail: 'detail',
};
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};
const status = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 2,
    label: '已下架',
  },
];
interface Form {
  name: string;
  community_id: number;
  area: string;
  list_image: string;
  house_image: string;
  style_id: number;
  detail_image: [];
  description: string;
}
function initStyleList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
function initFormValue(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    area: remote.area || '',
    community_id: remote.community_id || undefined,
    style_id: remote.style_id || undefined,
    list_image: remote.list_image || '',
    house_image: remote.house_image || '',
    detail_image: remote.detail_image || [],
    description: remote.description || '',
    recommend_type: remote.recommend_type || 0,
  };
}
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入名称',
    },
    {
      field: 'community_id',
      validate: (value: string): boolean => !!value,
      message: '请选择小区',
    },
    {
      field: 'area',
      validate: (value: string): boolean => !!value,
      message: '请输入面积',
    },
    {
      field: 'style_id',
      validate: (value: string): boolean => !!value,
      message: '请选择风格',
    },
    {
      field: 'list_image',
      validate: (value: string): boolean => !!value,
      message: '请选择列表图',
    },
    {
      field: 'detail_image',
      validate: (value: string): boolean => !!value.length,
      message: '请选择详情图',
    },
    {
      field: 'house_image',
      validate: (value: string): boolean => true,
      message: '请选择户型图',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}
@Component({
  components: {
    MultipleImageUpload,
    SingleImageUpload,
  },
})
export default class AddSence extends Vue {
  form_layout: any = {
    labelCol: { span: 2 },
    wrapperCol: { span: 16 },
  };
  id: number = 0;
  community_data: any = [];
  style_list: any = initStyleList();
  maxLength: number = 20;
  is_loading: boolean = false;
  is_edit: boolean = false;
  modal_image_src: string = '';
  is_show_image_modal: boolean = false;
  form: any = initFormValue();
  card_recommend: boolean = false;
  text_recommend: boolean = false;
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  get uploadDir() {
    return UPLOAD_DIR;
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  handlePreview(imageUrl: string) {
    this.modal_image_src = imageUrl;
    this.is_show_image_modal = true;
  }
  // 获取风格列表
  @changeLoading(['is_loading'])
  async getStyleList(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.style_list = initStyleList(res.data.data);
  }
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }
  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    return is_valid;
  }
  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 5) {
      this.$message.error('图片过大，请上传 5M 以内图片');
      return false;
    }
  }
  @changeLoading(['is_loading'])
  async getCommunityList() {
    const res = await this.$axios.get(API.get_cummunity_list);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.community_data = res.data.data;
  }
  async submit() {
    if (!this.validateCommit()) {
      return;
    }
    const recommend_type = this.card_recommend && this.text_recommend ? 3 : this.card_recommend ? 1 : this.text_recommend ? 2 : 0;
    const send_data = {
      name: this.form.name,
      style_id: this.form.style_id,
      community_id: this.form.community_id,
      area: this.form.area,
      list_image: this.form.list_image,
      detail_image: this.form.detail_image,
      house_image: this.form.house_image,
      description: this.form.description,
      recommend_type,
    };
    if (!this.is_edit) {
      const res: any = await this.$axios.post(API.add, send_data);
      if (res.data.status === 200) {
        this.$message.success('添加成功');
        this.$router.push('/operation/sence-example');
      }
    } else {
      const res: any = await this.$axios.put(`${API.add}/${this.id}`, send_data);
      if (res.data.status === 200) {
        this.$message.success('编辑成功');
        this.$router.push('/operation/sence-example');
      }
    }
  }
  async created() {
    if (this.$route.query.id) {
      this.is_edit = true;
      this.id = +this.$route.query.id;
      const res: any = await this.$axios.get(`${API.add}/${this.id}`);
      if (res.data.status === 200) {
        this.form = initFormValue(res.data.data);
        if (this.form.recommend_type === 3) {
          this.card_recommend = true;
          this.text_recommend = true;
        }
        if (this.form.recommend_type === 1) {
          this.card_recommend = true;
        }
        if (this.form.recommend_type === 2) {
          this.text_recommend = true;
        }
      }
    }
    this.getStyleList();
    this.getCommunityList();
  }
}
